import { palette } from "../../../../../styles/palette";

export const styles = {
  pageBody: {
    backgroundColor: palette.primaryWhite,
    borderRadius: 50,
    minHeight: "fit-content",
  },
};
